import PropTypes from "prop-types"
import { map } from "lodash"
import OPTooltip from "components/material/tooltip"

const SEGMENT_APPLIED_LABEL = "Segment Applied"

export default function CompareItemSubHeader({ additionalHeaders, segmentHeaderText }) {
  return <div>
    {map(additionalHeaders, (text, i) => {
      const isCollapsedSegment = !!segmentHeaderText && text === segmentHeaderText
      return <OPTooltip key={i} title={text}>
        <div data-ckey={i} data-test-class="compare-item-sub-header">{isCollapsedSegment ? SEGMENT_APPLIED_LABEL : text}</div>
      </OPTooltip>
    })}
  </div>
}

CompareItemSubHeader.propTypes = {
  additionalHeaders: PropTypes.arrayOf(PropTypes.string),
  segmentHeaderText: PropTypes.string,
}
